import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JuegoResponsableContentDataSource } from './juego-responsable-content-data-source';
import { ContentPage } from '../../models/content/content-page.model';

/**
 * JSON file-based juego responsable content data source.
 * Reads from /content/juego-responsable/*.json files.
 */
@Injectable()
export class JsonJuegoResponsableContentDataSource extends JuegoResponsableContentDataSource {
  private readonly basePath = '/content/juego-responsable';

  constructor(private readonly http: HttpClient) {
    super();
  }

  getPage(slug: string): Observable<ContentPage> {
    return this.http.get<ContentPage>(`${this.basePath}/${slug}.json`);
  }
}
